export default function stripQueryParams(url: string): string {
  try {
    const uri = new URL(url);
    const params = [...uri.searchParams.keys()];
    params.forEach(p => uri.searchParams.delete(p));
    return uri.toString();
  } catch (e) {
    return url;
  }
}
